/**
 * Who is visiting the museum: a household profile signed in at home (GET /api/session), or a
 * relative visiting through the Curator's Hub, whose museum answered their visit pass with a
 * bearer token (docs/family-setup.md §9.5; the API client holds it in memory).
 */
import type { HouseholdDTO } from '@galley/shared'
import { getMuseumTarget } from '../api/client'
import { useSession } from '../session/SessionProvider'

export function useHousehold(): HouseholdDTO | null {
  const { session } = useSession()
  return getMuseumTarget()?.household ?? session?.household ?? null
}

/** A visit through the hub (the museum is another site; its token lives in memory only). */
export function isRemoteVisit(): boolean {
  return getMuseumTarget() !== null
}
